<script setup>
import { reactive } from 'vue'
import useDevice from '../../../store/device.store'
import { localeDatePicker } from '../../../utils'
import { useQuasar } from 'quasar'
import { callApi } from '../../../utils'
import { useUrlQuery } from '../../../utils/useUrlQuery'
import { useI18n } from "vue-i18n"
const { t } = useI18n()

const $q = useQuasar()

const data = reactive({
  startTime: null,
  endTime: null,
  deviceId: null,
  deviceNumber: null
})

const { getDeviceList, loading, pagination } = useDevice()
const { pushToUrl, clearUrl } = useUrlQuery(data, filter)

function filter () {
  pushToUrl()
  callApi([getDeviceList], {
    'page-size': parseInt(pagination.value.rowsPerPage),
    'newer-than': data.startTime,
    'older-than': data.endTime,
    'device-id': data.deviceId,
    'device-number': data.deviceNumber,
  }, $q, loading, true)
}

function reset () {
  data.startTime = null
  data.endTime = null
  data.deviceId = null
  data.deviceNumber = null
  clearUrl()
  callApi([getDeviceList], { 
    'page-size': parseInt(pagination.value.rowsPerPage) 
  }, $q, loading, true)
}

</script>

<template lang='pug'>
.device-filter
  q-form(
    @submit='filter'
    @reset='reset'
    class="filter"
  )
    .column
      .col-auto.q-mb-md
        q-input(
          outlined
          v-model='data.startTime'
          :label='t("filter.time.start")'
          mask='####-##-## ##:##:##'
          hide-bottom-space
          hide-hint
        )
          template(v-slot:append)
            q-icon(name='schedule' class='cursor-pointer')
              q-popup-proxy
                div(style='border: 1px solid #ddd; border-radius: 10')
                  q-date(
                    v-model='data.startTime'
                    mask='YYYY-MM-DD HH:mm:ss'
                    minimal
                    :locale='localeDatePicker()'
                  )
      .col-auto.q-mb-md
        q-input(
          outlined
          v-model='data.endTime'
          :label='t("filter.time.end")'
          mask='####-##-## ##:##:##'
          hide-bottom-space
          hide-hint
        )
          template(v-slot:append)
            q-icon(name='schedule' class='cursor-pointer')
              q-popup-proxy
                div(style='border: 1px solid #ddd; border-radius: 10')
                  q-date(
                    v-model='data.endTime'
                    mask='YYYY-MM-DD HH:mm:ss'
                    minimal
                    :locale='localeDatePicker()'
                  )
      .col-auto.q-mb-md
        q-input(
          outlined
          v-model='data.deviceId'
          @update:modelValue='val => data.deviceId = val.toUpperCase()'
          :label='t("device.id")'
          hide-hint
          hide-bottom-space
        )
      .col-auto.q-mb-md
        q-input(
          outlined
          v-model='data.deviceNumber'
          mask="###-###"
          :label='t("device.number")'
          hide-hint
          hide-bottom-space
        )
      .col-auto.q-mb-md
        q-btn(
          style='width: 100%; height: 46px'
          :label="t('actions.clear')"
          :loading='loading'
          type="reset"
          flat
        )
      .col-auto
        q-btn(
          style='width: 100%; height: 46px'
          :label="t('actions.search')"
          :loading='loading'
          type="submit"
          outline
          size='auto'
          color='primary'
        )
</template>